import { store } from '@wordpress/interactivity';

const { state } = store('mediapress-listicle', {
  state: {
    get shouldShowLoadMore() {
      if (state.visibleItems === -1) {
        return false;
      }

      if (state.isReversed) {
        return state.visibleItems > 0;
      }

      return state.visibleItems < state.totalItems;
    },
  },
  actions: {
    loadMore: () => {
      const { visibleItems, paginationLimit, isReversed } = state;

      let nextIndexToShow = visibleItems + 1;

      if (isReversed) {
        nextIndexToShow = visibleItems;
        state.visibleItems -= paginationLimit;
      } else {
        state.visibleItems += paginationLimit;
      }

      setTimeout(() => {
        const item = document.querySelector(`[data-index="${nextIndexToShow}"]`);
        item?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    },
  },
});
